import React from 'react';
import styled from '@emotion/styled';
import loadableVisibility from 'react-loadable-visibility/loadable-components';
import BelowTheFold from 'shared/components/BelowTheFoldControl';
import { CAV_SECTION_ID } from 'shared/constants/productPage';
import AnimatedLoader from 'shared/components/BelowTheFoldControl/AnimatedLoader';


const Loading = styled(AnimatedLoader)`
  height: 388px;
`;

const Loadable = loadableVisibility(
  () => import(/* webpackChunkName: "product.btf.cav" */'./Loadable'),
  {
    fallback: <Loading className="client" id={CAV_SECTION_ID} />,
  },
);

const ServerOptimized = (props: any) =>
  (
    <BelowTheFold
      render={() => <Loadable {...props} />}
      loading={() => <Loading />}
    />
  )
;


export default ServerOptimized;
